var $ = require("jquery");
require("jquery.tabbable");

$(function () {
    var extraSpaceBelowFixedElements = 25,
        wsClickClass = "ws-click";

    var $body = $("body"),
        $window = $(window),
        $fixedElements = WS.getFixedElements(),
        $tabbableOff = $(".ws-tabbable_off");

    $(document).on("focus", "*", function (event) {
        if (event.currentTarget !== event.target) {
            return;
        }

        var $target = $(event.currentTarget);
        if (!$target.is(":tabbable")) {
            return;
        }

        var scrollTop = $window.scrollTop();
        var bottomOfLowestFixedElement = 0;
        var targetIsInFixedElement = false;
        $fixedElements.each(function () {
            var $element = $(this);
            if (!$element.is(":visible")) {
                return true;
            }

            var cssPosition = $element.css("position").toLowerCase();
            if (cssPosition !== "sticky" && cssPosition !== "fixed") {
                return true;
            }

            var bounds = $element.get(0).getBoundingClientRect();
            if (cssPosition === "sticky" && parseInt($element.css("top")) < bounds.top) {
                return true;
            }

            if ($.contains(this, event.currentTarget)) {
                targetIsInFixedElement = true;
                return false;
            }

            var elementBottom = bounds.bottom + scrollTop;
            if (elementBottom > bottomOfLowestFixedElement) {
                bottomOfLowestFixedElement = elementBottom;
            }
        });

        if (targetIsInFixedElement || !bottomOfLowestFixedElement) {
            return;
        }

        var targetTop = $target.offset().top;
        if (targetTop >= bottomOfLowestFixedElement) {
            return;
        }

        $window.scrollTop(targetTop + scrollTop - bottomOfLowestFixedElement - extraSpaceBelowFixedElements);
    });

    $(document).on("focus", ".ws-pseudo-focus, .ws-pseudo-focus *", function (event) {
        if (event.currentTarget !== event.target) {
            return;
        }

        var focusTarget = getPseudoFocusTarget(event.currentTarget);
        if (focusTarget) {
            $(focusTarget).addClass("ws-visually-focused");
        }
    });

    $(document).on("blur", ".ws-pseudo-focus, .ws-pseudo-focus *", function (event) {
        if (event.currentTarget !== event.target) {
            return;
        }

        var focusTarget = getPseudoFocusTarget(event.currentTarget);
        if (focusTarget) {
            $(focusTarget).removeClass("ws-visually-focused");
        }
    });

    $body.on("mousedown", function () {
        $(this).toggleClass(wsClickClass, true);
    });

    $body.on("keydown", function (e) {
        switch (e.which) {
            case 9:
            case 40:
            case 37:
            case 39:
            case 38:
            case 32:
            case 27:
            case 13:
                //spacebar, enter, tab, escape, and arrow keys
                $body.toggleClass(wsClickClass, false);
                break;
            default:
                break;
        }
    });

    // keydown on an enter triggers a click, so take off the ws-click class on keyup of enter
    $body.on("keyup", function (e) {
        switch (e.which) {
            case 13:
                $body.toggleClass(wsClickClass, false);
                break;
            case 32:
                if (e.target.nodeName.toLowerCase() === "button") {
                    // the setTimeout below fixes an issue where wsClickClass was being re-added to the body by a different event handler. using setTimeout
                    // ensures this bit of code runs after other handlers have finished executing.
                    setTimeout(function () {
                        $body.toggleClass(wsClickClass, false);
                    }, 0);
                }
                break;
            default:
                break;
        }
    });

    function getPseudoFocusTarget(eventTarget) {
        var $target = $(eventTarget);
        var $pseudoFocus = $target.hasClass("ws-pseudo-focus") ? $target : $target.parents(".ws-pseudo-focus");
        if ($pseudoFocus.length) {
            var $focusTarget = $($pseudoFocus.data("focus-target"));
            return $focusTarget.length ? $focusTarget[0] : null;
        }

        return null;
    }

    $tabbableOff.attr("tabindex", "-1");
});